import React from 'react';

import { Fade } from '@column/column-ui-kit';
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader } from '@column/ui';

import { ROUTE } from '~/app/routes';
import { Logo } from '~/elements/Logo';
import { useNavigate } from '~/lib/navigation';
import { useSessionStore } from '~/stores/Session';

import { NavMain } from './NavMain';
import { NavPlatform } from './NavPlatform';
import { NavSecondary } from './NavSecondary';
import { useNavItems } from './useNavItems';

const SidebarLogo: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="relative flex h-[31px] items-center px-2">
      <button
        type="button"
        onClick={() => navigate(ROUTE.ROOT)}
        className="-mt-[3px] flex cursor-pointer items-center border-0 bg-transparent p-0 outline-none"
      >
        <Logo variant="word" size="16" data-logo-target />
      </button>
    </div>
  );
};

export const AppSidebar: React.FC<React.ComponentProps<typeof Sidebar>> = (props) => {
  const { currentUser } = useSessionStore();
  const navItems = useNavItems();

  return (
    <Sidebar variant="inset" {...props}>
      <SidebarHeader className="pt-[calc(0.25rem+env(safe-area-inset-top))] pb-0 gap-2 max-lg:pt-[calc(0.625rem+env(safe-area-inset-top))]">
        <SidebarLogo />
        <Fade show={!!currentUser}>
          <NavPlatform />
        </Fade>
      </SidebarHeader>
      <Fade show={!!currentUser} className="flex min-h-0 flex-1 flex-col">
        <SidebarContent>
          <NavMain items={navItems} />
        </SidebarContent>
        <SidebarFooter className="pb-[calc(0.5rem+env(safe-area-inset-bottom))]">
          <NavSecondary />
        </SidebarFooter>
      </Fade>
    </Sidebar>
  );
};
